import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'app-error-dialog',
    templateUrl: './error-dialog.component.html',
    styleUrls: ['./error-dialog.component.scss'],
    standalone: false
})
export class ErrorDialogComponent {
  error: string;

  constructor(@Inject(MAT_DIALOG_DATA) private data) {
    this.error = this.data.dialogData;
  }
}
